
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f9e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f9e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8Mzka", function(module, exports) {
$parcel$export(module.exports, "convertError", () => (parcelRequire("gwpIs")).convertError);
$parcel$export(module.exports, "ERROR_REASONS", () => (parcelRequire("gwpIs")).ERROR_REASONS);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("gwpIs")).SentryError);
$parcel$export(module.exports, "CloseModalEvent", () => (parcelRequire("1z6rf")).CloseModalEvent);
$parcel$export(module.exports, "createConnection", () => (parcelRequire("1z6rf")).createConnection);
$parcel$export(module.exports, "Event", () => (parcelRequire("1z6rf")).Event);
$parcel$export(module.exports, "eventFactory", () => (parcelRequire("1z6rf")).eventFactory);
$parcel$export(module.exports, "OpenModalCompleteEvent", () => (parcelRequire("1z6rf")).OpenModalCompleteEvent);
$parcel$export(module.exports, "OpenModalEvent", () => (parcelRequire("1z6rf")).OpenModalEvent);
$parcel$export(module.exports, "OpenPopupBlockedEvent", () => (parcelRequire("1z6rf")).OpenPopupBlockedEvent);
$parcel$export(module.exports, "OpenPopupCompleteEvent", () => (parcelRequire("1z6rf")).OpenPopupCompleteEvent);
$parcel$export(module.exports, "OpenPopupErrorEvent", () => (parcelRequire("1z6rf")).OpenPopupErrorEvent);
$parcel$export(module.exports, "OpenPopupEvent", () => (parcelRequire("1z6rf")).OpenPopupEvent);
$parcel$export(module.exports, "PopupQueryStateEvent", () => (parcelRequire("1z6rf")).PopupQueryStateEvent);
$parcel$export(module.exports, "startListening", () => (parcelRequire("1z6rf")).startListening);

$parcel$export(module.exports, "envs", () => (parcelRequire("l04Zv")));
$parcel$export(module.exports, "environments", () => (parcelRequire("9HEWA")));
$parcel$export(module.exports, "createLogger", () => (parcelRequire("biN6x")).createLogger);
$parcel$export(module.exports, "urls", () => (parcelRequire("fSB8m")));

var $l04Zv = parcelRequire("l04Zv");

var $9HEWA = parcelRequire("9HEWA");
parcelRequire("gwpIs");
parcelRequire("1z6rf");

var $biN6x = parcelRequire("biN6x");

var $fSB8m = parcelRequire("fSB8m");

});
parcelRegister("l04Zv", function(module, exports) {

$parcel$export(module.exports, "getWrapperEnv", () => $8c922ec1372a5fa2$export$74ecc4a9bd17e55c);
$parcel$export(module.exports, "getAppEnv", () => $8c922ec1372a5fa2$export$c5f9c10e769dff78);

var $9HEWA = parcelRequire("9HEWA");
const $8c922ec1372a5fa2$export$74ecc4a9bd17e55c = (0, $9HEWA.environmentMapper)({
    "https://localhost.corp.adobe.com:8080": (0, $9HEWA.ENVIRONMENTS).local,
    "https://auth-light-sample.identity-stage.adobe.com": (0, $9HEWA.ENVIRONMENTS).stage,
    "https://auth-light-sample.identity-prestage.adobe.com": (0, $9HEWA.ENVIRONMENTS).prestage,
    "https://auth-light-sample.identity-preprod.adobe.com": (0, $9HEWA.ENVIRONMENTS).preprod
});
const $8c922ec1372a5fa2$export$c5f9c10e769dff78 = (0, $9HEWA.environmentMapper)({
    "https://localhost.corp.adobe.com:25000": (0, $9HEWA.ENVIRONMENTS).local,
    "https://auth-light.identity-stage.adobe.com": (0, $9HEWA.ENVIRONMENTS).stage,
    "https://auth-light.identity-prestage.adobe.com": (0, $9HEWA.ENVIRONMENTS).stage,
    "https://auth-light.identity-preprod.adobe.com": (0, $9HEWA.ENVIRONMENTS).prod
});

});
parcelRegister("9HEWA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ENVIRONMENTS", () => $73f0a8b804d90df4$export$ad0fa068a57bdc3a);
$parcel$export(module.exports, "environmentMapper", () => $73f0a8b804d90df4$export$426337ee9481be56);
$parcel$export(module.exports, "byEnvironment", () => $73f0a8b804d90df4$export$c8619508fe34dae4);
$parcel$export(module.exports, "default", () => $73f0a8b804d90df4$export$2e2bcd8739ae039);
const $73f0a8b804d90df4$export$ad0fa068a57bdc3a = {
    local: "local",
    stage: "stage",
    prestage: "prestage",
    preprod: "preprod",
    prod: "prod"
};
function $73f0a8b804d90df4$export$426337ee9481be56(map) {
    return (url = window.origin)=>{
        var _map_url;
        return (_map_url = map[url]) !== null && _map_url !== void 0 ? _map_url : $73f0a8b804d90df4$export$ad0fa068a57bdc3a.prod;
    };
}
const $73f0a8b804d90df4$var$isEnvironment = (getEnvironment)=>(env)=>{
        return getEnvironment() === env;
    };
function $73f0a8b804d90df4$export$c8619508fe34dae4(getEnvironment) {
    return function byEnvironment(envToFnMap) {
        const env = getEnvironment();
        return envToFnMap[env]();
    };
}
function $73f0a8b804d90df4$export$2e2bcd8739ae039(getEnvironment) {
    return {
        isEnvironment: $73f0a8b804d90df4$var$isEnvironment(getEnvironment),
        byEnvironment: $73f0a8b804d90df4$export$c8619508fe34dae4(getEnvironment)
    };
}

});


parcelRegister("gwpIs", function(module, exports) {

$parcel$export(module.exports, "ERROR_REASONS", () => $4c98bf5a5bacc55e$export$85b027bf1c0c3c10);
$parcel$export(module.exports, "SentryError", () => $4c98bf5a5bacc55e$export$5949942ba2a7c0e2);
$parcel$export(module.exports, "convertError", () => $4c98bf5a5bacc55e$export$f555a51577ce160);
const $4c98bf5a5bacc55e$export$85b027bf1c0c3c10 = {
    undefined: "undefined",
    critical: "critical",
    generic: "generic",
    unrecoverable: "unrecoverable"
};
function $4c98bf5a5bacc55e$var$toStringError(error) {
    if (error instanceof $4c98bf5a5bacc55e$export$5949942ba2a7c0e2) return error.toString();
    if (error instanceof Error) {
        const message = error.message ? `: ${error.message}` : "";
        return error.name + message;
    }
    return "";
}
class $4c98bf5a5bacc55e$export$5949942ba2a7c0e2 extends Error {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            stack: this.stack
        };
    }
    toString() {
        const error = `${this.name}: ${this.message}`;
        const originalErrorString = $4c98bf5a5bacc55e$var$toStringError(this.originalError).replaceAll("\n", "\n	");
        return `${error}\n\t<- ${originalErrorString}`;
    }
    get name() {
        return this.type;
    }
    get stack() {
        var _this_originalError;
        var _this_originalError_stack;
        return (_this_originalError_stack = (_this_originalError = this.originalError) === null || _this_originalError === void 0 ? void 0 : _this_originalError.stack) !== null && _this_originalError_stack !== void 0 ? _this_originalError_stack : this.stack;
    }
    static extendError(sentryError, originalError) {
        if (originalError && originalError instanceof Error) sentryError.originalError = originalError;
        return sentryError;
    }
    static generic(originalError) {
        const error = new $4c98bf5a5bacc55e$export$7d465be8efa67280();
        return $4c98bf5a5bacc55e$export$5949942ba2a7c0e2.extendError(error, originalError);
    }
    static critical(causeMessage, originalError) {
        const error = new $4c98bf5a5bacc55e$export$4b42a7a78fede561(causeMessage);
        return $4c98bf5a5bacc55e$export$5949942ba2a7c0e2.extendError(error, originalError);
    }
    static unrecoverable(causeMessage, originalError) {
        const error = new $4c98bf5a5bacc55e$export$58a7ae465253b2fa(causeMessage);
        return $4c98bf5a5bacc55e$export$5949942ba2a7c0e2.extendError(error, originalError);
    }
    constructor(...args){
        super(...args);
        this.type = $4c98bf5a5bacc55e$export$85b027bf1c0c3c10.undefined;
        this.cause = "";
    }
}
class $4c98bf5a5bacc55e$export$7d465be8efa67280 extends $4c98bf5a5bacc55e$export$5949942ba2a7c0e2 {
    constructor(...args){
        super(...args);
        this.type = $4c98bf5a5bacc55e$export$85b027bf1c0c3c10.generic;
    }
}
class $4c98bf5a5bacc55e$export$4b42a7a78fede561 extends $4c98bf5a5bacc55e$export$5949942ba2a7c0e2 {
    constructor(...args){
        super(...args);
        this.type = $4c98bf5a5bacc55e$export$85b027bf1c0c3c10.critical;
    }
}
class $4c98bf5a5bacc55e$export$58a7ae465253b2fa extends $4c98bf5a5bacc55e$export$5949942ba2a7c0e2 {
    constructor(...args){
        super(...args);
        this.type = $4c98bf5a5bacc55e$export$85b027bf1c0c3c10.unrecoverable;
    }
}
function $4c98bf5a5bacc55e$export$f555a51577ce160(input) {
    if (input instanceof $4c98bf5a5bacc55e$export$5949942ba2a7c0e2) return input;
    if (input instanceof Error) return $4c98bf5a5bacc55e$export$5949942ba2a7c0e2.generic(input);
    return $4c98bf5a5bacc55e$export$5949942ba2a7c0e2.generic(new Error(String(input)));
}

});

parcelRegister("1z6rf", function(module, exports) {

$parcel$export(module.exports, "Event", () => $07885baf174d1c0f$export$d61e24a684f9e51);
$parcel$export(module.exports, "OpenPopupEvent", () => $07885baf174d1c0f$export$47edff89ee5eefdb);
$parcel$export(module.exports, "OpenModalEvent", () => $07885baf174d1c0f$export$b9a2c15ca74dee47);
$parcel$export(module.exports, "CloseModalEvent", () => $07885baf174d1c0f$export$4518ed92bbb25c89);
$parcel$export(module.exports, "OpenModalCompleteEvent", () => $07885baf174d1c0f$export$6fdc11b9e9b0a645);
$parcel$export(module.exports, "OpenPopupCompleteEvent", () => $07885baf174d1c0f$export$6ddaf5c7fdb615c5);
$parcel$export(module.exports, "OpenPopupBlockedEvent", () => $07885baf174d1c0f$export$43a7920667fb5990);
$parcel$export(module.exports, "OpenPopupErrorEvent", () => $07885baf174d1c0f$export$aa36cdda8cc1d9c0);
$parcel$export(module.exports, "PopupQueryStateEvent", () => $07885baf174d1c0f$export$9b94066e3b15bd87);
$parcel$export(module.exports, "createConnection", () => $07885baf174d1c0f$export$f28ca1a95bdaacaa);
$parcel$export(module.exports, "startListening", () => $07885baf174d1c0f$export$5a3c9ae1fa6d7e61);
$parcel$export(module.exports, "eventFactory", () => $07885baf174d1c0f$export$c9526fa4526c2c60);

var $gwpIs = parcelRequire("gwpIs");
function $07885baf174d1c0f$export$38cf933889b055d9(eventStr) {
    const prefixLength = eventStr.indexOf("-");
    const metaDataLength = eventStr.indexOf(":");
    const event = eventStr.substring(0, prefixLength);
    const side = eventStr.substring(prefixLength + 1, metaDataLength);
    const data = eventStr.substring(metaDataLength + 1);
    return {
        event: event,
        side: side,
        data: data
    };
}
class $07885baf174d1c0f$export$d61e24a684f9e51 {
    setData(data) {
        if (data) return $07885baf174d1c0f$export$d61e24a684f9e51.create({
            name: this.name,
            side: this.side,
            data: data
        });
        else return this;
    }
    compareTo(event) {
        return this.name === event.name && this.side === event.side;
    }
    of(base) {
        return this.compareTo(base);
    }
    toString() {
        return JSON.stringify(this);
    }
    static fromString(eventStr) {
        if (typeof eventStr !== "string") throw new TypeError("Event: Event couldn't be created. Invalid value.");
        const parse = JSON.parse(eventStr);
        if (parse && Object.prototype.hasOwnProperty.call(parse, "side") && Object.prototype.hasOwnProperty.call(parse, "name")) return new $07885baf174d1c0f$export$d61e24a684f9e51(JSON.parse(eventStr));
        else throw new TypeError("Event: Event incorrectly formatted. Missing side or name.");
    }
    static parse(eventStr, assertedEvent) {
        const event = this.fromString(eventStr);
        if (event.compareTo(assertedEvent)) return event;
        else return null;
    }
    static create(params) {
        return new $07885baf174d1c0f$export$d61e24a684f9e51(params);
    }
    constructor({ name: name, side: side, data: data }){
        this.name = name;
        this.side = side;
        this.data = data;
    }
}
const $07885baf174d1c0f$export$9071af2ede914ef4 = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "init",
    side: "app"
});
const $07885baf174d1c0f$export$6a03e30751fc8429 = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "response",
    side: "wrapper",
    data: {}
});
const $07885baf174d1c0f$export$91f51023bb6bac2f = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "complete",
    side: "app"
});
const $07885baf174d1c0f$export$c4a23014fbd7877d = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "error",
    side: "app",
    data: (0, $gwpIs.SentryError).unrecoverable("Unknown error.")
});
const $07885baf174d1c0f$export$47edff89ee5eefdb = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "open-popup",
    side: "app",
    data: ""
});
const $07885baf174d1c0f$export$b9a2c15ca74dee47 = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "on-modal-open",
    side: "proxy",
    data: {
        dimensions: {
            height: 550,
            width: 400
        },
        reason: "unknown"
    }
});
const $07885baf174d1c0f$export$4518ed92bbb25c89 = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "on-modal-close",
    side: "proxy"
});
const $07885baf174d1c0f$export$6fdc11b9e9b0a645 = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "open-modal-complete",
    side: "wrapper"
});
const $07885baf174d1c0f$export$6ddaf5c7fdb615c5 = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "open-popup-complete",
    side: "wrapper"
});
const $07885baf174d1c0f$export$43a7920667fb5990 = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "open-popup-blocked",
    side: "wrapper"
});
const $07885baf174d1c0f$export$aa36cdda8cc1d9c0 = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "open-popup-error",
    side: "popup",
    data: ""
});
const $07885baf174d1c0f$export$9b94066e3b15bd87 = $07885baf174d1c0f$export$d61e24a684f9e51.create({
    name: "query-state",
    side: "popup",
    data: ""
});
function $07885baf174d1c0f$export$f28ca1a95bdaacaa(targetOrigin, targetWindow = window.parent) {
    return new Promise((resolve, reject)=>{
        if (!targetOrigin) reject((0, $gwpIs.SentryError).unrecoverable("Invalid target origin."));
        // Send Init event and second port to establish connection
        const channel = new MessageChannel();
        targetWindow.postMessage($07885baf174d1c0f$export$9071af2ede914ef4.toString(), targetOrigin, [
            channel.port2
        ]);
        // Wait for ResponseEvent from Wrapper
        channel.port1.onmessage = function(e) {
            const response = $07885baf174d1c0f$export$d61e24a684f9e51.parse(e.data, $07885baf174d1c0f$export$6a03e30751fc8429);
            if (response) {
                channel.port1.postMessage($07885baf174d1c0f$export$91f51023bb6bac2f.toString());
                // Resolve with Wrapper data and port
                resolve({
                    port: channel.port1,
                    channel: channel,
                    state: response.data
                });
            } else reject($07885baf174d1c0f$export$c4a23014fbd7877d.setData((0, $gwpIs.SentryError).unrecoverable("Wrong wrapper response.")));
        };
    });
}
function $07885baf174d1c0f$export$9d816695ec3452c1(allowedOrigin) {
    return new Promise((resolve, reject)=>{
        window.addEventListener("message", function listener(e) {
            if (e.origin !== allowedOrigin) return;
            const event = $07885baf174d1c0f$export$d61e24a684f9e51.fromString(e.data);
            if (event.of($07885baf174d1c0f$export$9071af2ede914ef4)) resolve(e.ports[0]);
            if (event.of($07885baf174d1c0f$export$c4a23014fbd7877d)) reject(event);
            window.removeEventListener("message", listener);
        });
    });
}
function $07885baf174d1c0f$export$a08fb5cc915b7487(port, state) {
    return new Promise((resolve, reject)=>{
        // Wait for Complete event
        port.onmessage = function(e) {
            const event = $07885baf174d1c0f$export$d61e24a684f9e51.parse(e.data, $07885baf174d1c0f$export$91f51023bb6bac2f);
            if (event) resolve(port);
            else reject($07885baf174d1c0f$export$c4a23014fbd7877d.setData((0, $gwpIs.SentryError).unrecoverable("Invalid Sentry reponse to the connection.")));
        };
        // Send Response event
        $07885baf174d1c0f$export$6a03e30751fc8429.data = state;
        port.postMessage($07885baf174d1c0f$export$6a03e30751fc8429.toString());
    });
}
function $07885baf174d1c0f$export$5a3c9ae1fa6d7e61(port) {
    const eventEmitter = new $07885baf174d1c0f$export$4fae95256245c8c0();
    port.onmessage = function(event) {
        eventEmitter.broadcast($07885baf174d1c0f$export$d61e24a684f9e51.fromString(event.data));
    };
    port.onmessageerror = function() {
        eventEmitter.broadcast($07885baf174d1c0f$export$c4a23014fbd7877d.setData((0, $gwpIs.SentryError).unrecoverable("Port message error.")));
    };
    window.addEventListener("storage", ({ key: key, newValue: newValue })=>{
        try {
            if (key === "popupEvent" && newValue) {
                const event = $07885baf174d1c0f$export$d61e24a684f9e51.fromString(newValue);
                if (event.of($07885baf174d1c0f$export$9b94066e3b15bd87)) {
                    const returnEvent = $07885baf174d1c0f$export$d61e24a684f9e51.fromString(event.data);
                    eventEmitter.broadcast(returnEvent);
                }
            }
        } catch (e) {
            console.error(e);
        } finally{
            localStorage.removeItem("popupEvent");
        }
    });
    const eventScheduler = new $07885baf174d1c0f$export$e0c335d02293e8fa(eventEmitter);
    return function() {
        return eventScheduler;
    };
}
class $07885baf174d1c0f$export$4fae95256245c8c0 {
    get numListeners() {
        return this.listeners.size;
    }
    add(listener) {
        this.listeners.add(listener);
    }
    remove(listener) {
        this.listeners.delete(listener);
    }
    broadcast(event) {
        this.listeners.forEach((listener)=>{
            listener.emit(event);
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}
class $07885baf174d1c0f$export$e0c335d02293e8fa {
    subscribe(fn) {
        const listener = new $07885baf174d1c0f$export$3291343375ee8b92(fn);
        this.emitter.add(listener);
        return ()=>{
            this.emitter.remove(listener);
        };
    }
    once(fn) {
        let disposer;
        const promise = new Promise((res)=>{
            disposer = this.subscribe((event)=>res(event));
        });
        promise.catch(()=>disposer());
        if (fn) return promise.then((event)=>fn(event)).then(()=>disposer());
        else return promise;
    }
    listenFor(listenedEvent) {
        return new Promise((res, rej)=>{
            const disposer = this.subscribe((event)=>{
                if (listenedEvent.compareTo(event)) {
                    res(event);
                    disposer();
                }
            });
        });
    }
    constructor(emitter){
        this.emitter = emitter;
    }
}
class $07885baf174d1c0f$export$3291343375ee8b92 {
    emit(event) {
        this.listener(event);
    }
    constructor(listener){
        this.listener = listener;
    }
}
function $07885baf174d1c0f$export$c9526fa4526c2c60(port) {
    return (event)=>(data)=>{
            event.data = data;
            port.postMessage(event.toString());
            return null;
        };
}

});

parcelRegister("biN6x", function(module, exports) {

$parcel$export(module.exports, "createLogger", () => $0216369ea994f98b$export$fe2e61603b61130d);

var $9HEWA = parcelRequire("9HEWA");
function $0216369ea994f98b$export$fe2e61603b61130d(getEnv, clientId, relay = "", name = "default") {
    const env = (0, $9HEWA.byEnvironment)(getEnv);
    const endpoint = env({
        [(0, $9HEWA.ENVIRONMENTS).local]: ()=>"https://localhost.corp.adobe.com:8081/signin",
        [(0, $9HEWA.ENVIRONMENTS).stage]: ()=>"https://auth-stg1.services.adobe.com/signin/v1/audit",
        [(0, $9HEWA.ENVIRONMENTS).prestage]: ()=>"https://auth-stg1.services.adobe.com/signin/v1/audit",
        [(0, $9HEWA.ENVIRONMENTS).preprod]: ()=>"https://auth.services.adobe.com/signin/v1/audit",
        [(0, $9HEWA.ENVIRONMENTS).prod]: ()=>"https://auth.services.adobe.com/signin/v1/audit"
    });
    const envName = env({
        [(0, $9HEWA.ENVIRONMENTS).local]: ()=>"susi-light-local",
        [(0, $9HEWA.ENVIRONMENTS).stage]: ()=>"susi-light-stage",
        [(0, $9HEWA.ENVIRONMENTS).prestage]: ()=>"susi-light-prestage",
        [(0, $9HEWA.ENVIRONMENTS).preprod]: ()=>"susi-light-preprod",
        [(0, $9HEWA.ENVIRONMENTS).prod]: ()=>"susi-light-prod"
    });
    return function logger(message) {
        return fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-IMS-CLIENTID": clientId,
                "X-DEBUG-ID": relay
            },
            body: JSON.stringify({
                name: name,
                envName: envName,
                clientId: clientId,
                message: message
            })
        }).catch((e)=>{});
    };
}

});

parcelRegister("fSB8m", function(module, exports) {

$parcel$export(module.exports, "getApiUrl", () => $383f672323a6b4df$export$1b98eaf73d37f034);
$parcel$export(module.exports, "getFederatedUrl", () => $383f672323a6b4df$export$f952767a492cb9b4);
$parcel$export(module.exports, "getAuthServicesUrl", () => $383f672323a6b4df$export$f59a4c477164a56a);
$parcel$export(module.exports, "getAdobeidServicesUrl", () => $383f672323a6b4df$export$b4f94fd2634bbbc0);
$parcel$export(module.exports, "getAppUrl", () => $383f672323a6b4df$export$7086db7f8cfa1126);
$parcel$export(module.exports, "getPopupUrl", () => $383f672323a6b4df$export$fb180f11d351b294);
$parcel$export(module.exports, "sentryUrl", () => $383f672323a6b4df$export$c0be0235fa958cd7);
$parcel$export(module.exports, "create", () => $383f672323a6b4df$export$185802fd694ee1f5);

var $9HEWA = parcelRequire("9HEWA");
function $383f672323a6b4df$export$1b98eaf73d37f034(getEnvironment) {
    return ()=>(0, $9HEWA.byEnvironment)(getEnvironment)({
            [(0, $9HEWA.ENVIRONMENTS).local]: ()=>"https://ims-na1-stg1.adobelogin.com",
            [(0, $9HEWA.ENVIRONMENTS).stage]: ()=>"https://ims-na1-stg1.adobelogin.com",
            [(0, $9HEWA.ENVIRONMENTS).prestage]: ()=>"https://ims-na1-stg1.adobelogin.com",
            [(0, $9HEWA.ENVIRONMENTS).preprod]: ()=>"https://ims-na1.adobelogin.com",
            [(0, $9HEWA.ENVIRONMENTS).prod]: ()=>"https://ims-na1.adobelogin.com"
        });
}
function $383f672323a6b4df$export$f952767a492cb9b4(getEnvironment) {
    return ()=>(0, $9HEWA.byEnvironment)(getEnvironment)({
            [(0, $9HEWA.ENVIRONMENTS).local]: ()=>"https://federatedid-na1-stg1.services.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).stage]: ()=>"https://federatedid-na1-stg1.services.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).prestage]: ()=>"https://federatedid-na1-stg1.services.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).preprod]: ()=>"https://federatedid-na1.services.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).prod]: ()=>"https://federatedid-na1.services.adobe.com"
        });
}
function $383f672323a6b4df$export$f59a4c477164a56a(getEnvironment) {
    return ()=>(0, $9HEWA.byEnvironment)(getEnvironment)({
            [(0, $9HEWA.ENVIRONMENTS).local]: ()=>"http://localhost.corp.adobe.com:3000",
            [(0, $9HEWA.ENVIRONMENTS).stage]: ()=>"https://auth-stg1.services.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).prestage]: ()=>"https://auth-stg1.services.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).preprod]: ()=>"https://auth.services.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).prod]: ()=>"https://auth.services.adobe.com"
        });
}
function $383f672323a6b4df$export$b4f94fd2634bbbc0(getEnvironment) {
    return ()=>(0, $9HEWA.byEnvironment)(getEnvironment)({
            [(0, $9HEWA.ENVIRONMENTS).local]: ()=>"http://localhost.corp.adobe.com:3000",
            [(0, $9HEWA.ENVIRONMENTS).stage]: ()=>" https://adobeid-na1-stg1.services.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).prestage]: ()=>"https://adobeid-na1-stg1.services.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).preprod]: ()=>"https://adobeid-na1.services.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).prod]: ()=>"https://adobeid-na1.services.adobe.com"
        });
}
function $383f672323a6b4df$export$7086db7f8cfa1126(getEnvironment) {
    return ()=>(0, $9HEWA.byEnvironment)(getEnvironment)({
            [(0, $9HEWA.ENVIRONMENTS).local]: ()=>"https://localhost.corp.adobe.com:25000",
            [(0, $9HEWA.ENVIRONMENTS).stage]: ()=>"https://auth-light.identity-stage.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).prestage]: ()=>"https://auth-light.identity-prestage.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).preprod]: ()=>"https://auth-light.identity-preprod.adobe.com",
            [(0, $9HEWA.ENVIRONMENTS).prod]: ()=>"https://auth-light.identity.adobe.com"
        });
}
function $383f672323a6b4df$export$fb180f11d351b294(getEnvironment) {
    return ()=>(0, $9HEWA.byEnvironment)(getEnvironment)({
            [(0, $9HEWA.ENVIRONMENTS).local]: ()=>"https://localhost.corp.adobe.com:25000/wrapper-popup-helper/index.html",
            [(0, $9HEWA.ENVIRONMENTS).stage]: ()=>"https://auth-light.identity-stage.adobe.com/wrapper-popup-helper/index.html",
            [(0, $9HEWA.ENVIRONMENTS).prestage]: ()=>"https://auth-light.identity-prestage.adobe.com/wrapper-popup-helper/index.html",
            [(0, $9HEWA.ENVIRONMENTS).preprod]: ()=>"https://auth-light.identity-preprod.adobe.com/wrapper-popup-helper/index.html",
            [(0, $9HEWA.ENVIRONMENTS).prod]: ()=>"https://auth-light.identity.adobe.com/wrapper-popup-helper/index.html"
        });
}
const $383f672323a6b4df$export$c0be0235fa958cd7 = (getEnvironment, forceStage = false)=>function sentryUrl(variant) {
        const envUrl = $383f672323a6b4df$export$7086db7f8cfa1126(forceStage ? ()=>(0, $9HEWA.ENVIRONMENTS).stage : getEnvironment)();
        const url = new URL(envUrl || "");
        url.hash = variant;
        return url;
    };
function $383f672323a6b4df$export$185802fd694ee1f5(getEnvironment) {
    return {
        getApiUrl: $383f672323a6b4df$export$1b98eaf73d37f034(getEnvironment),
        getAppUrl: $383f672323a6b4df$export$7086db7f8cfa1126(getEnvironment),
        getFederatedUrl: $383f672323a6b4df$export$f952767a492cb9b4(getEnvironment),
        getAuthServicesUrl: $383f672323a6b4df$export$f59a4c477164a56a(getEnvironment),
        getAdobeidServicesUrl: $383f672323a6b4df$export$b4f94fd2634bbbc0(getEnvironment),
        getPopupUrl: $383f672323a6b4df$export$fb180f11d351b294(getEnvironment),
        sentryUrl: $383f672323a6b4df$export$c0be0235fa958cd7(getEnvironment)
    };
}

});



//# sourceMappingURL=index.2cf5cd25.js.map
